<template>
    <div>
        <el-dialog
            title="置业顾问团队列表"
            :visible.sync="showconsultantspicker"
            width="900px"
            append-to-body
            :before-close="close">
            <div class="base-warp">
                <div class="head">
                    <el-form ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="名称">
                            <el-input v-model="keyword" placeholder="输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="团队类型">
                            <el-select v-model="teamtype" value-key="" placeholder="请选择" clearable filterable >
                                <el-option label="自销团队" value="自销团队"></el-option>
                                <el-option label="代理团队" value="代理团队"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否上架">
                            <el-select v-model="putaway" value-key="" placeholder="请选择" clearable filterable >
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confrim">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    stripe 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                        <el-table-column prop="teamtype" label="团队类型" ></el-table-column>
                        <el-table-column prop="name" label="名称" ></el-table-column>
                        <el-table-column prop="projectname" label="关联楼盘" ></el-table-column>
                        <el-table-column prop="admin.name" label="管理员" ></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span v-if="s.row.putaway==true" class="text text-success">上架中</span>
                                <span v-else class="text text-warning">下架中</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="s">
                                <el-button type="success" size="mini" @click="checkrow(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'ConsultantTeamList',
    data() {
        return {
            keyword: '',
            putaway: '',
            teamtype: '',
            tabledata: [],
            pageNo: 1,
            pagesize: 14,
            total: 0,
        }
    },
    computed: {
        showconsultantspicker: {
            get() {
                return this.$store.getters.getshowconsultantspicker;
            },
            set(val) {
                this.$store.commit('setshowconsultantspicker', val);
            },
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        close() {
            this.$store.commit('setshowconsultantspicker', false);
        },
        checkrow(item) {
            this.$emit('getconsultant', item);
            this.close();
        },
        gettabledata() {
            var params = {
                keyword: this.keyword,
                teamtype: this.teamtype,
                putaway: this.putaway,
                pagesize: this.pagesize,
                pageNo: this.pageNo
            };
            this.$api.getConsultantTeamList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        confrim() {
            this.pageNo = 1;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.base-warp{
    .head{
        ::v-deep .el-input__inner{
            width: 160px;
        }
    }
}
</style>